var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKaiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.529,
    height: 42.126,
    viewBox: "0 0 57.529 42.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(-842.471 -469.437)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_-ai",
    "data-name": "-ai",
    transform: "translate(869 503)",
    fontSize: 25,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-ai")), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1.505,5.9C1.854,5.26,7.709-.049,8.2,0S5.182,37.91,4.876,39.011.3,43.626.016,43.3,1.157,6.538,1.505,5.9Z",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 863.49, 469.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M.08,3.288C.4,2.611,6.868,1.395,6.868,1.395S14.517-.134,15.174.02s2.369,2.686,1.888,3.047S6.518,5.1,5.77,7.274s-.907,13.748-1.123,13.8A41.483,41.483,0,0,1,.634,15.434C.532,14.981-.24,3.964.08,3.288Z",
    transform: "translate(854.543 496.405) rotate(-44)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaiIcon);
export default __webpack_public_path__ + "static/media/kai-icon.a828c7dd1826c8c148f33351f01e71f5.svg";
export { ForwardRef as ReactComponent };